export default {
  /*
  [PREFERENCE.EXAMPLE]: value,
  */
};
